<template>
    <div class="tile-contact-form-container grid-container" :class="config.theme">
        <div class="grid-xl-1 grid-xs-0"></div>
        <div class="control-wrapper grid-xl-10 grid-xs-12">
            <div class="pretitle" v-if="labels.get('Tile Pretitle')">{{ labels.get('Tile Pretitle') }}</div>
            <div class="title">{{ labels.get('Tile Title') }}</div>
            <div class="description">{{ labels.get('Tile Description') }}</div>
            <button class="tile-cta hoverable" @click="showContactForm">{{ labels.get('Tile CTA') }}</button>
        </div>
        <div class="grid-xl-1 grid-xs-0"></div>
    </div>
</template>

<script>
import ServiceManager from "../services/service-manager";

export default {
    name: "TileContactBox",
    components: {

    },
    props: [],
    data() {
        return {
            labels: ServiceManager.getService(this, "Labels"),
            config: ServiceManager.getService(this, "Config"),
        }
    },
    methods: {
        showContactForm() {
            this.$emit("showContactForm");
        }
    }
}
</script>

<style scoped>
.control-wrapper {
    padding: 56px 0px;
}

.pretitle {
    margin: 0 0 16px 0;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
}

.title {
    font-weight: 500;
    font-size: 40px;
    line-height: 48px;
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    margin-bottom: 16px;
}

.description {
    font-weight: 300;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 32px;
}

.tile-cta {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    padding: 16px 25px;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    cursor: pointer;
}

@media all and (max-width:480px) {
    .control-wrapper {
        padding: 40px 20px;
    }

    .pretitle {
        margin: 0 0 16px 0;
        font-weight: 700;
        font-size: 8px;
        line-height: 10px;
    }

    .title {
        font-weight: 700;
        font-size: 16px;
        line-height: 27px;
        margin-bottom: 8px;
    }

    .description {
        font-weight: 300;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 24px;
    }

    .tile-cta {
        padding: 12px 17px;
    }
}
</style>